import React, { useContext, useEffect, useRef, useState } from "react"
import {Box, Button} from "@material-ui/core"
import {useFormik} from "formik";
import {NavLink} from "react-router-dom";
import style from "./style.module.scss"
import {useTheme} from "@material-ui/core/styles";
import textIcon from "./assets/terminoliesIcon.svg"
import { useTranslation } from "react-i18next";
import { useParams, Redirect } from "react-router-dom"
import TLServiceComponent from "../../../../contexts/TLServiceComponent"
import { useSelector } from "react-redux"
import { addReturnValues, checkUserRight, cleanSettings, deepCopy, fillSettingsWithDefault, flattenSettingsWithListValues, generateNameDesc, getSettWithLists, getSettWOLists, parseErrorObject, toastError, toastSuccess } from "../../../../utils"
import { ToastContainer } from "react-toastify"
import MainPageWrapper from "../../../Main-page-wrapper"
import Spinner from "../../../Spinner"
import Profile from "./Profile"
import Section from "./Sections/Section"
import config from "../../../../config"
import SectionWithLists from "./Sections/SectionWithLists"
import UserRightTable from "./UGC"
import { useActions } from "../../../../utils/action-helper"
import { userGetAllTermCategories } from "../../../../actions"
import { ArrowBackIos, Save } from "@material-ui/icons"

export default function TextTypesForm({match: {params: {page}}}) {

  const { t } = useTranslation()
  const {theme: {bgColors, colors}} = useTheme()
  const [benchmarks, setBenchmarks] = useState([])
  const [templates, setTemplates] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [spinner, setSpinner] = useState(false)
  const [rights, setRights] = useState([])
  const [hovered, setHovered] = useState(null)
  const [tab, setTab] = useState(config.TABS_TEXTTYPE.RIGHTS)
  const [redirect, setRedirect] = useState(false)
  const submitBtnRef = useRef(null)
  const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
  const isDark = themeState === config.THEMES_MODES.CONTRAST_DARK
  const { id } = useParams()
  const tlService = useContext(TLServiceComponent)
  const token = useSelector((state) => state.userData.token)
  const user = useSelector(state => state.userData.user)
  const backendLanguages = useSelector(state => state.userData.user?.backend_languages || {})
  const categories = useSelector((state) => state.adminData.sett_categories || {}) 
  const settings_dir = useSelector((state) => state.adminData.settings_dir || {})
  const termCategories = useSelector(state => state.userData.termCategories)

  const { actionGetAllGetAllTermCategories } = useActions({actionGetAllGetAllTermCategories: userGetAllTermCategories(tlService)})

  const categoriesWithoutLists = Object.keys(categories).filter(val => config.allSectionNames.withoutLists.includes(val)).reduce((acc, key) => {
    acc[key] = categories[key]
    return acc
  }, {})
  const categoriesWithLists = Object.keys(categories).filter(val => config.allSectionNames.withLists.includes(val)).reduce((acc, key) => {
    acc[key] = categories[key]
    return acc
  }, {})

  const activeHoverStyle = {
    borderBottom: `3px solid ${colors.colorText}`,
    color: colors.colorText
  }

  const settingPropertiesWOLists = Object.values(categoriesWithoutLists).map(val => val.map(val => val.key)).flat()
  const settingPropertiesWithLists = Object.values(categoriesWithLists).map(val => val.map(val => val.key)).flat()
  
  const allSectionsWithLists = checkUserRight(user) ? config.allSectionNames.withLists : config.allSectionNamesAdmin.withLists
  const allSectionsWithoutLists = checkUserRight(user) ? config.allSectionNames.withoutLists : config.allSectionNamesAdmin.withoutLists

  const formik = useFormik({
    initialValues: {
      template: config.textTypedefaultValues.BENCHMARK_TEMPLATE,
      language: Object.keys(backendLanguages).length > 0 ? Object.keys(backendLanguages)[0] : '',
      autoTranslate: true,
      ...Object.keys(backendLanguages).length > 0 ? Object.keys(backendLanguages).reduce((acc, key) => {
        acc[`name${key}`] = ''
        acc[`description${key}`] = ''
        return acc
      }
      , {}) : {},
    },
    onSubmit: values => {
      postBenchmark(values, submitBtnRef.current)
    }
  })

  function filterSettingByCalcelements(settings, calcelements) {
    let retSetting = {}
    for (const [key, value] of Object.entries(settings)) {
      if (calcelements.indexOf(value['lib']) !== -1)
        retSetting[key] = value
    }
    return retSetting
  }

  const fillFormik = async () => {
    let filterIs
    let res
    filterIs = { id: id }
    if (!!id) {
      if(!templates.length > 0){
        try {
          setSpinner(true)
          res = await tlService.getFilteredBenchmarks(token, {}, filterIs)
          setBenchmarks(res)
        } catch (e) {
          setSpinner(false)
          const erMessage = parseErrorObject(e)
          if (erMessage?.number === 404 || erMessage?.number === 403) {
            toastError(t('admin_texttype_texttype-not-found'), bgColors, colors)
          }  else {
            toastError(t(erMessage.message), bgColors, colors)
          }
          setRedirect(true)
          return false
        }
  
        if (res.data && res.data.length > 0) {
          const data = res.data[0]
          formik.initialValues.template = data.benchmark_template_id ? data.benchmark_template_id : config.textTypedefaultValues.BENCHMARK_TEMPLATE
          formik.initialValues.language = data.locale_name ? data.locale_name : Object.keys(backendLanguages).length > 0 ? Object.keys(backendLanguages)[0] : ''
          for (const key of Object.keys(backendLanguages)) {
            const lang = key.split('_')[0]
            formik.initialValues[`name${key}`] = data.name[lang] || ''
            formik.initialValues[`description${key}`] = data.description[lang] || ''
          }          
          formik.initialValues.settings = data.settings
          for (const key of settingPropertiesWOLists) {
            if (data.settings[key] && data.settings[key].values) {
              for (const newKey of Object.keys(data.settings[key].values)) {
                if (!config.textTypeExcludedFieldList.includes(newKey)) {
                  formik.initialValues[`${key}${newKey}`] = data.settings[key].values[newKey]
                }
              }
            }
          }
          flattenSettingsWithListValues(data.settings, settingPropertiesWithLists, (key, value) => {
            formik.initialValues[key] = value
          })
          setRights(data.rights ? data.rights : [])
          setSpinner(false)
        }
      }
    } 
    else {
      const template = templates.find(temp => temp.id === formik.values.template)

      if (template) {
        setSpinner(true)
        const sectionSet = filterSettingByCalcelements(
          settings_dir,
          template['default_calcelements'].reduce((acc, value) => [...acc, value[0]], []))
        let settings = {}
        for (const [sectionSet_key, sectionSet_value] of Object.entries(sectionSet)) {
          settings[sectionSet_key] = deepCopy(sectionSet_value)
          for (const [sectionSet_value_key, sectionSet_value_value] of Object.entries(sectionSet_value['values'])) {
            settings[sectionSet_key]['values'][sectionSet_value_key] = deepCopy(sectionSet_value_value[2])
          }
        }
        const updatedValues = {
          ...formik.values,
          template: template.id,
          language: template.locale_name,
          ...Object.keys(backendLanguages).length > 0 ? Object.keys(backendLanguages).reduce((acc, key) => {
            const lang = key.split('_')[0]
            acc[`name${key}`] = template.name[lang]
            acc[`description${key}`] = template.description[lang]
            return acc
          }, {}) : {},
          settings
        }
        fillSettingsWithDefault(settings, settings_dir)
        for (const key of settingPropertiesWOLists) {
          if (settings[key] && settings[key].values) {
            for (const newKey of Object.keys(settings[key].values)) {
              if (!config.textTypeExcludedFieldList.includes(newKey)) {
                updatedValues[`${key}${newKey}`] = settings[key].values[newKey]
              }
            }
          }
        }        
        flattenSettingsWithListValues(settings, settingPropertiesWithLists, (key, value) => {
          updatedValues[key] = value
        })
        formik.setValues(updatedValues)
        setSpinner(false)
      }
    }
  }

  const postBenchmark = async (values, action) => {
    if(!!id){
      const name = generateNameDesc('name', backendLanguages, values)
      const description = generateNameDesc('description', backendLanguages, values)

      const settingsWOLists = getSettWOLists(settingPropertiesWOLists, values)
      const settingsWithLists = getSettWithLists(settingPropertiesWithLists, values)

      const allSettings = {
        ...settingsWOLists,
        ...settingsWithLists
      }

      const returnValues = addReturnValues(allSettings, settings_dir)  
      const cleanedSettings = cleanSettings(fillSettingsWithDefault(allSettings, settings_dir))

      try {
        setSpinner(true)
        await tlService.updateBenchmark(token, id, JSON.stringify(name), JSON.stringify(description), undefined, JSON.stringify(returnValues), JSON.stringify(cleanedSettings))
        setSubmitted(true)
        setSpinner(false)
        toastSuccess(t('admin_texttype_update-success-msg'), bgColors, colors)
      } catch (e) {
        setSpinner(false)
        console.log('error', e)
        const erMessage = parseErrorObject(e)
        toastError(t(erMessage.message), bgColors, colors)
        return false
      }

      let toDelete = []
      const oldRights = benchmarks.data[0].rights
      let toAdd
      if (oldRights && oldRights.length > 0) {
        toDelete = oldRights.filter(d => !rights.includes(d))
        toAdd = rights.filter(d => !oldRights.includes(d))
      } else {
        toAdd = rights
      }

      for (let right of toAdd) {
        try {
          await tlService.addBenchmarkUGC(token,
            parseInt(id),
            right[0] ? parseInt(right[0][0]) : 0,
            right[1] ? parseInt(right[1][0]) : 0,
            right[2] ? parseInt(right[2][0]) : 0
          )
        } catch (e) {
          const erMessage = parseErrorObject(e)
          toastError(t(erMessage.message), bgColors, colors)
          return false
        }
      }
      for (let right of toDelete) {
        try {
          await tlService.deleteBenchmarkUGC(token,
            parseInt(id),
            right[0] ? parseInt(right[0][0]) : 0,
            right[1] ? parseInt(right[1][0]) : 0,
            right[2] ? parseInt(right[2][0]) : 0
          )
        } catch (e) {
          const erMessage = parseErrorObject(e)
          toastError(t(erMessage.message), bgColors, colors)
          return false
        }
      }
      if (action === config.BUTTON_REF.SAVE_N_GO) {
        setRedirect(true)
      } else {
        setRedirect(false)
      }
    } 
    else {
      const name = generateNameDesc('name', backendLanguages, values)
      const description = generateNameDesc('description', backendLanguages, values)

      const settingsWOLists = getSettWOLists(settingPropertiesWOLists, values)
      const settingsWithLists = getSettWithLists(settingPropertiesWithLists, values)

      const allSettings = {
        ...settingsWOLists,
        ...settingsWithLists
      }

      const returnValues = addReturnValues(allSettings, settings_dir)
      const cleanedSettings = cleanSettings(fillSettingsWithDefault(allSettings, settings_dir))
      let res
      try {
        setSpinner(true)
        res = await tlService.addBenchmark(token, JSON.stringify(name), JSON.stringify(description), values.template, JSON.stringify({}), JSON.stringify(returnValues), JSON.stringify(cleanedSettings))
        setSubmitted(true)
        setSpinner(false)
        toastSuccess(t('admin_texttype_create-success-msg'), bgColors, colors)
      } catch (e) {
        setSpinner(false)
        const erMessage = parseErrorObject(e)
        toastError(t(erMessage.message), bgColors, colors)
        return false
      }
      // add rights
      if (res && res.id) {
        const newId = res.id
        for (let right of rights) {
          try {
            await tlService.addBenchmarkUGC(token,
              parseInt(newId),
              right[0] ? parseInt(right[0][0]) : 0,
              right[1] ? parseInt(right[1][0]) : 0,
              right[2] ? parseInt(right[2][0]) : 0
            )
          } catch (e) {
            const erMessage = parseErrorObject(e)
            toastError(t(erMessage.message), bgColors, colors)
            return false
          }
        }
        setRedirect(true)
      }
    }
  }  

  const handleRights = (newRights) => {
    setRights(newRights)
  }

  useEffect(() => {
    if (termCategories.length === 0) {
      actionGetAllGetAllTermCategories(token)
    }
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [termCategories.length])

  useEffect(() => {
    const fetchTemplates = async () => {
      try {
       const templates = await tlService.getBenchmarkTemplates(token)
        setTemplates(templates.data)
      } catch (e) {
        console.log('error', e)
      }
    }
    fetchTemplates()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setTab(config.TABS_TEXTTYPE.RIGHTS)
  }, [formik.values.template])


  useEffect(() => {
    fillFormik()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, submitted, JSON.stringify(categories), JSON.stringify(templates), formik.values.template])

  const handleTabChange = (e, tabName) => {
    e.preventDefault()
    setTab(tabName)
  }
  if (redirect) {
    return <Redirect to="/administration/text-types"/>
  }

  if (spinner)
    return <div className={'w-100 align-content-center text-center align-items-center'}><Spinner /></div>
  return (
    <MainPageWrapper>
      <ToastContainer autoClose={5000} position="top-center" hideProgressBar={false} draggable pauseOnHover
        closeOnClick />
    <form className={`pb-5 ${style.mainCont}`} onSubmit={formik.handleSubmit}>
      <NavLink className={`${style.breadcrumb}`} to="/administration/text-types" exact={true}>
        <Button style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }} variant="contained">
            <ArrowBackIos className='mr-2' />
          {t('admin_texttype_title')}
        </Button>
      </NavLink>
        <div className={`d-flex align-items-center justify-content-between mb-3 ${style.head}`}>
          <div className={"d-flex"}>
            <img src={textIcon} style={{ width: 50, height: 50, filter: isDark ? "invert(1)" : "none"}} alt="" />
            <h1 style={{ color: colors.colorPrimary1000 }} className={`${style.title} d-flex align-items-center`}>
              {t('admin_texttype_title')}</h1>
          </div>
          <div>
            {!!id && <Button type="submit" variant={"contained"} style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }}
              onClick={() => submitBtnRef.current = config.BUTTON_REF.SAVE}
              className={`mr-2`}>
              <Save className={`mr-2`}/>
              {t('admin_texttype_save')}
            </Button>}
            <Button type="submit" variant={"contained"} style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorContrast }} className={`mr-2`} onClick={() => submitBtnRef.current = config.BUTTON_REF.SAVE_N_GO} >
              <ArrowBackIos className='mr-2' />
              <Save className={`mr-2`}/> {t('admin_texttype_save_go')}
            </Button>
          </div>
        </div> 
     <Profile formik={formik} templates={templates} id={id} backendLanguages={backendLanguages} />
        <Box className="mb-2" style={{ margin: "25px 0px 15px 0px", padding: 1}}>
      <div className={`${style.navigations}`}>
        <button type="button" onClick={(e) => handleTabChange(e, config.TABS_TEXTTYPE.RIGHTS)} onMouseEnter={() => setHovered(config.TABS_TEXTTYPE.RIGHTS)} onMouseLeave={() => setHovered(null)} style={{color: colors.colorOn, ...(tab === config.TABS_TEXTTYPE.RIGHTS || hovered === config.TABS_TEXTTYPE.RIGHTS ? activeHoverStyle : {})}}>
          {t('admin_texttype_ugc')}
        </button>
        <button type="button" onMouseEnter={() => setHovered(config.TABS_TEXTTYPE.SETTINGS)} onMouseLeave={() => setHovered(null)} onClick={(e) => handleTabChange(e, config.TABS_TEXTTYPE.SETTINGS)} style={{color: colors.colorOn, ...(tab === config.TABS_TEXTTYPE.SETTINGS || hovered === config.TABS_TEXTTYPE.SETTINGS ? activeHoverStyle : {})}}>
          {t('admin_texttype_settings')}
        </button>
      </div>
    </Box>
        <div>
          { tab === config.TABS_TEXTTYPE.RIGHTS ?  <UserRightTable translate={t} handleRights={handleRights} rights={rights} /> : 
          <div>
              {allSectionsWithoutLists.map((sect) => {
            return <Section key={sect} formik={formik} section={sect} />
              }
          )}
          {allSectionsWithLists.map((sect) => {
            return <SectionWithLists key={sect} formik={formik} section={sect} catType={config.catTypes[sect]}/>
          }
          )}
            </div>
            }
          </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "1.8rem" }}>
          {!!id && <Button type="submit" variant={"contained"} color={"primary"}
            style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorPrimary0 }}
            className={`mr-2`} onClick={() => submitBtnRef.current = config.BUTTON_REF.SAVE} >
            <Save className={`mr-2`}/> {t('admin_texttype_save')}
          </Button>}
          <Button type="submit" variant={"contained"} color={"primary"} style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorPrimary0 }} className={`mr-2`} onClick={() => submitBtnRef.current = config.BUTTON_REF.SAVE_N_GO}>
            <ArrowBackIos className={`mr-2`} />
            <Save className={`mr-2`}/>{t('admin_texttype_save_go')}
          </Button>
        </div>
    </form>
    </MainPageWrapper>
  ) 
}
